<template>
  <v-container fluid class="gallery-page mt-6">
    <v-row>
      <template v-for="visit in visitsData">
        <v-col
          cols="12"
          md="6"
          lg="4"
          :key="visit.id"
          >
          <v-card
            class="mx-1 mb-1"
            link
            :ripple="{class: 'ripple-color' }"
            replace
            :key="visit.id"
            >
            <v-card-text>
              <table style="margin:0px; padding:0px">
                <tr>
                  <td>
                    <div v-if="visit.userid!=undefined" style="margin-bottom:5px;">
                      <v-avatar v-if="users.length>0 && users.find(user=>user._id == visit.userid)!==null" size="45">
                        <img v-bind:src="users.find(user=>user._id == visit.userid)['userimage']" alt="">
                      </v-avatar>
                      <v-avatar
                        v-else
                        color="warning"
                        size="45">
                        <span class="white--text headline">{{ users.length>0 && users.find(user=>user._id == visit.userid)!==null ? users.find(user=>user._id == visit.userid)['username'][0].toUpperCase() : '' }}</span>
                      </v-avatar>
                    </div>
                  </td>
                  <td>
                    <p style="margin:0px; padding: 0px"><span style="margin-left:5px; font-size: 12pt">{{ users.length>0 ? users.find(user=>user._id == visit.userid)['username'] : '' }}</span></p>
                    <p style="margin: 0px; padding: 0px"><span style="margin-left:5px; font-size: 9pt">
                      {{ new Date(visit.createdAt).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric' }) }}
                    </span></p>
                  </td>
                </tr>
              </table>
              <div style="margin-top: 10px; height: 40px; text-overflow: ellipsis; word-break: normal; overflow: hidden;">
                <p class="two-line">{{ visit.text }}</p>
                <p class="two-line">{{ visit.tags }}</p>
              </div>
            </v-card-text>
            <div v-if="visit.thumbnails.length==1" style="padding: 3px">
              <v-img
                width="100%"
                max-height="310"
                object-fit="cover"
                :src="visit.thumbnails[0]"
              ></v-img>
            </div>
            <div v-else-if="visit.thumbnails.length==2">
              <div style="padding: 3px; margin:0;">
              <v-img
                width="100%"
                height="153"
                object-fit="cover"
                :src="visit.thumbnails[0]"
              ></v-img>
              </div>
              <div style="padding: 3px; margin:0;">
              <v-img
                width="100%"
                height="153"
                object-fit="cover"
                :src="visit.thumbnails[1]"
              ></v-img>
              </div>
            </div>
            <div v-else-if="visit.thumbnails.length==3" style="padding: 3px">
              <div style="padding-bottom: 3px;">
                 <v-img
                    width="100%"
                    height="150"
                    object-fit="cover"
                    :src="visit.thumbnails[0]"
                  ></v-img>
              </div>
              <div style="display:inline-block; width: 50%; height:150px; padding:3px;">
                 <img
                    width="100%"
                    height="150"
                    object-fit="cover"
                    :src="visit.thumbnails[1]"
                  >
              </div>
              <div style="display:inline-block; width: 50%; height:150px; padding:3px;">
                 <img
                    width="100%"
                    height="150"
                    object-fit="cover"
                    :src="visit.thumbnails[2]"
                  >
              </div>
            </div>
            <div v-else-if="visit.thumbnails.length==4" style="display: inline-block; padding: 3px">
              <div style="display:inline-block; width: 50%; padding-right: 3px;">
                 <img
                    width="100%"
                    height="150"
                    :src="visit.thumbnails[0]"
                    object-fit="cover"
                  >
              </div>
              <div style="display:inline-block;  width: 50%; padding-left: 3px;">
                 <img
                    width="100%"
                    height="150"
                    :src="visit.thumbnails[1]"
                    object-fit="cover"
                  >
              </div>
              <div style="display:inline-block;  width: 50%; padding-right: 3px">
                 <img
                    width="100%"
                    height="150"
                    :src="visit.thumbnails[2]"
                    object-fit="cover"
                  >
              </div>
              <div style="display:inline-block;  width: 50%; padding-left: 3px">
                 <img
                    width="100%"
                    height="150"
                    :src="visit.thumbnails[3]"
                    object-fit="cover"
                  >
              </div>
            </div>
            <v-card-actions>
              <v-btn icon>
                <v-icon>mdi-heart</v-icon>
              </v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-col>
      </template>
    </v-row>
  </v-container>
</template>

<script>
import { mapState, mapActions } from 'vuex';
export default {
  name: 'Gallery',
  data (){
    return {
      visitsData: []
    }
  },
  computed: {
    ...mapState('Visit', ['visits']),
    ...mapState('User', ['users']),
  },
  async created () {
    if(this.users.length==0) await this.getUsersRequest();
    if(this.visits.length==0) await this.getVisitsRequest();
    console.log(this.visits)
    this.visitsData = this.visits.map(visit=>{return {id: visit._id, text: visit.visittext, userid: visit.creator._id, createdAt: visit.createdAt, thumbnails: visit.visitthumbnails, images: visit.visitimages, tags: visit.visittags,}})
    console.log(this.visitsData)
  },
    methods: {
    ...mapActions('Visit', ["getVisitsRequest"]),
    ...mapActions('User', ["getUsersRequest"]),
  },
}

</script>

<style src="./List.scss" lang="scss"></style>
